import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  contentDialog: {
    maxHeight: 'calc(100vh - 64px)',
  },
}));

export default useStyles;
